<script setup lang="ts">
import { ref } from 'vue';

const emits = defineEmits<{
  onCancel: [];
  onConfirm: [];
}>();

const visible = defineModel<boolean>('visible', { default: false });

const confirmed = ref(false);

// EVENTS
function onCancel() {
  visible.value = false;
}

function onConfirm() {
  confirmed.value = true;
  visible.value = false;
  emits('onConfirm');
}

function onAfterHide() {
  if (confirmed.value) {
    confirmed.value = false;
    return;
  }

  emits('onCancel');
}
</script>

<template>
  <Dialog
    v-model:visible="visible"
    modal
    class="relative mx-4 max-h-full w-full sm:max-h-[95vh] sm:w-[600px]"
    pt:content="overflow-hidden pb-[74px]"
    pt:header="justify-end"
    @after-hide="onAfterHide"
  >
    <div class="confirmation-content flex flex-col items-center gap-5 text-center">
      <i class="pi pi-exclamation-triangle mr-3 text-6xl text-orange-400" />

      <span>
        {{ $t('components.notes.replaceTemplateConfirm') }}
      </span>
    </div>

    <template #footer>
      <Button
        class="af-button"
        severity="secondary"
        :label="$t('common.cancel')"
        @click="onCancel"
      />

      <Button
        class="af-button"
        icon="pi pi-check"
        severity="danger"
        :label="$t('common.yes')"
        @click="onConfirm"
      />
    </template>
  </Dialog>
</template>
